import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';

const Title = ({ title, titleUrl }) => (
  <h2 className="cover-spread__headline" data-test="cover-spread__headline">
    {titleUrl ? (
      <Link href={titleUrl}>
        {title}
      </Link>
    ) : title}
  </h2>
);

Title.propTypes = {
  title: PropTypes.string.isRequired,
  titleUrl: PropTypes.string,
};

Title.defaultProps = {
  titleUrl: null,
};

export default Title;
